import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";
function Block7() {

    return (
            <section className="layout-pt-20 layout-pb-60">
                <div className="auto-container">
                    <div className="sec-title-outer">
                        <div className="sec-title" style={{width: "100%", textAlign: "center"}}>
                            <h2 className="homepage">Pourquoi une <span>hotline Handicap ?</span></h2>
                            <div className="text homepage">Plusieurs raisons font que beaucoup de collaborateurs <span>ne s’identifient pas au handicap</span> ou <span>cachent leur situation de handicap</span>
                            </div>
                        </div>
                    </div>

                    <div className="row wow fadeInUp">

                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="feature-block">
                                <div className="inner-box">
                                    <figure className="image homepage">
                                        <img src="/images/resource/femme-heureuse.jpg" alt="support-client"
                                             className="homepage"/>
                                    </figure>
                                    <div className="overlay-box">
                                        <div className="content">
                                            <h5>80 % des handicaps sont invisibles</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="feature-block">
                                <div className="inner-box">
                                    <figure className="image">
                                        <img src="/images/resource/chaise-roulante.jpg" alt="stigmatisation"
                                             className="homepage"/>
                                    </figure>
                                    <div className="overlay-box">
                                        <div className="content">
                                            <h5>Peur de la stigmatisation et de la discrimination</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="feature-block">
                                <div className="inner-box">
                                    <figure className="image">
                                        <img src="/images/resource/femme-affaires.jpg" alt="préjugés"
                                             className="homepage"/>
                                    </figure>
                                    <div className="overlay-box">
                                        <div className="content">
                                            <h5>Beaucoup de préjugés et de stéréotypes sur le handicap</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="feature-block">
                                <div className="inner-box">
                                    <figure className="image">
                                        <img src="/images/resource/pause-cafe.jpg" alt="méconnaissance des droits"
                                             className="homepage"/>
                                    </figure>
                                    <div className="overlay-box">
                                        <div className="content">
                                            <h5>Méconnaissance des droits et bénéfices d’être reconnu travailleur
                                                handicapé</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="sec-title-outer">
                        <div className="sec-title">
                            <div className="text homepage">
                                Dissimuler sa situation de handicap peut priver une personne d’un <span>environnement de travail adapté</span>,
                                mettre en danger sa santé et augmenter les risques d’inaptitude ou de perte d’emploi. En offrant la Hotline Talents Handicap à vos collaborateurs,
                                vous les encouragez à <span>s’informer de manière confidentielle et anonyme</span>, pour révéler leur situation de handicap et <span>bénéficier de conditions de travail adaptées,</span>
                                favorables à leur santé et à leur emploi.
                            </div>
                            <div className="text-center">
                                <ContactModal textButton="Échangeons sur vos besoins" showText={false} small="small" linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block7;
